module.exports = __webpack_public_path__ + "img/dab_dworski.252ae5ba.jpg";